// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"3bdb0e99","180":"aa2e467d","285":"2d4724f5","431":"6544261c","453":"fd428e45"}[chunkId] + ".chunk.js";
};